import * as React from 'react'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'

import { SearchParameters, config as typesenseConfig, typesenseQuery } from '../../../../typeSense'
import { getDashboardId } from '../../../../helpers/getDashboardId'

import {
  SearchWrapper,
  StyledInput,
  StyledLabel,
  StyledButton,
  CloseButton,
  OptionButton,
  OptionDropdown,
  ButtonWrapper,
  FiltersWrapper,
  StatusButton,
  FilterButton,
  FlexWrapper,
  MainFlexWrapper,
} from './search-section.style'
interface Props {
  onChange?: (e) => void
  onOptionChange?: (e) => void
  onStatusChange?: (e) => void
  onClearInput?: () => void
  addMemberButton?: () => void
  placeholder?: string
  buttonText?: string
  hideButton?: boolean
  options?: boolean
  brandOrderUuid?: string
  searchToken?: string
}

const SearchSection: React.FC<Props> = ({
  onChange,
  addMemberButton,
  onClearInput,
  onOptionChange,
  onStatusChange,
  placeholder,
  buttonText,
  hideButton,
  options,
  searchToken,
  brandOrderUuid,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('')
  const [optionDropdownActive, setOptionDropdownActive] = React.useState(false)
  const [statusDropdownActive, setStatusDropdownActive] = React.useState(false)
  const [projectStatuses, setProjectStatuses] = React.useState<any>([])

  const initalOptions = [
    {
      id: 1,
      name: 'Order',
      value: 'name',
      active: true,
    },
    {
      id: 2,
      name: 'Location',
      value: 'location',
      active: true,
    },
    {
      id: 3,
      name: 'Due Date',
      value: 'dueDate',
      active: true,
    },
    {
      id: 4,
      name: 'Created At',
      value: 'createdAt',
      active: true,
    },
    {
      id: 5,
      name: 'Payment Type',
      value: 'paymentType',
      active: true,
    },
    {
      id: 6,
      name: 'Workflow',
      value: 'numberOfVideos',
      active: true,
    },
    {
      id: 7,
      name: 'Price',
      value: 'orderPrice',
      active: true,
    },
    {
      id: 8,
      name: 'Contract Type',
      value: 'contractType',
      active: true,
    },
    {
      id: 9,
      name: 'Status',
      value: 'projectStatus',
      active: true,
    },
  ]

  const [optionsData, setOptionsData] = React.useState(initalOptions)
  const [statusOptionsData, setStatusOptionsData] = React.useState<any[]>([])

  const isMounted = React.useRef(true)

  const optionIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00062 5.49997C5.6199 5.49997 4.50062 6.61926 4.50062 7.99997C4.50062 9.38068 5.6199 10.5 7.00062 10.5C8.38133 10.5 9.50062 9.38068 9.50062 7.99997C9.50062 6.61926 8.38133 5.49997 7.00062 5.49997ZM5.50062 7.99997C5.50062 7.17154 6.17219 6.49997 7.00062 6.49997C7.82904 6.49997 8.50062 7.17154 8.50062 7.99997C8.50062 8.8284 7.82904 9.49997 7.00062 9.49997C6.17219 9.49997 5.50062 8.8284 5.50062 7.99997Z"
        fill="#1E1E21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.27709 2.15482C8.62348 -0.13543 5.37775 -0.135429 4.72414 2.15482C4.52163 2.86443 3.7926 3.28533 3.07681 3.10591C0.766585 2.52683 -0.856283 5.33772 0.800331 7.04888C1.31361 7.57907 1.31361 8.42088 0.800331 8.95106C-0.856283 10.6622 0.766585 13.4731 3.07681 12.894C3.7926 12.7146 4.52163 13.1355 4.72414 13.8451C5.37775 16.1354 8.62348 16.1354 9.27709 13.8451C9.4796 13.1355 10.2086 12.7146 10.9244 12.894C13.2346 13.4731 14.8575 10.6622 13.2009 8.95106C12.6876 8.42088 12.6876 7.57907 13.2009 7.04888C14.8575 5.33772 13.2346 2.52683 10.9244 3.10591C10.2086 3.28533 9.4796 2.86443 9.27709 2.15482ZM5.68575 2.42925C6.06326 1.10643 7.93797 1.10643 8.31549 2.42925C8.6661 3.65781 9.92829 4.38654 11.1676 4.0759C12.5019 3.74143 13.4393 5.36497 12.4824 6.35332C11.5938 7.27124 11.5938 8.7287 12.4824 9.64662C13.4393 10.635 12.5019 12.2585 11.1676 11.924C9.92829 11.6134 8.6661 12.3421 8.31549 13.5707C7.93797 14.8935 6.06326 14.8935 5.68575 13.5707C5.33513 12.3421 4.07294 11.6134 2.83367 11.924C1.49931 12.2585 0.561954 10.635 1.5188 9.64662C2.40745 8.7287 2.40745 7.27124 1.5188 6.35332C0.561955 5.36497 1.49931 3.74143 2.83367 4.0759C4.07294 4.38654 5.33513 3.65781 5.68575 2.42925Z"
        fill="#1E1E21"
      />
    </svg>
  )

  React.useEffect(
    () => {
      const newStatuses =
        projectStatuses &&
        projectStatuses.map((status, index) => ({
          id: index,
          name: status.value,
          active: status.value === 'Lost' ? false : true,
          count: status.count,
        }))
      setStatusOptionsData(newStatuses)
    },
    [projectStatuses]
  )

  React.useEffect(
    () => {
      onOptionChange && onOptionChange(optionsData)
    },
    [optionsData]
  )

  const localStorageSearchTerm = localStorage.getItem('searchTerm')
  React.useEffect(() => {
    setSearchTerm(localStorageSearchTerm || '')
  }, [])

  const onStateChangeFunction = data => {
    const filteredStatuses = data.map(status => {
      if (status && status.active) {
        return status.name
      }
    })
    onStatusChange && onStatusChange(filteredStatuses)
  }
  React.useEffect(
    () => {
      onStateChangeFunction(statusOptionsData)
    },
    [statusOptionsData]
  )

  React.useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  React.useEffect(
    () => {
      onOptionChange && onOptionChange(optionsData)
    },
    [optionsData]
  )
  const outsideClickHandler = ref => {
    React.useEffect(
      () => {
        const handleClickOutside = event => {
          if (ref.current && !ref.current.contains(event.target)) {
            setOptionDropdownActive(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      },
      [ref]
    )
  }
  const wrapperRef = React.useRef(null)
  outsideClickHandler(wrapperRef)

  const handleOptionsData = (index: number, stateFunction: (data: any) => void) => {
    const newOptionData = optionsData.map((c, i) => {
      if (i === index) {
        return { ...c, active: !c.active }
      }
      return c
    })
    stateFunction && stateFunction(newOptionData)
  }

  const handleStatusData = (index: number, stateFunction: (data: any) => void) => {
    const newStatuses =
      statusOptionsData &&
      statusOptionsData.map((c, i) => {
        if (i === index) {
          return { ...c, active: !c.active }
        }
        return c
      })
    stateFunction && stateFunction(newStatuses)
  }

  const arrowSvgIcon = (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 8.46008C7.77984 8.46008 7.57082 8.36337 7.42832 8.19557L3.42832 3.48551C3.16019 3.16979 3.19878 2.69648 3.5145 2.42836C3.83022 2.16023 4.30353 2.19881 4.57165 2.51454L7.99998 6.55145L11.4283 2.51454C11.6964 2.19881 12.1697 2.16023 12.4855 2.42836C12.8012 2.69648 12.8398 3.16979 12.5717 3.48551L8.57165 8.19557C8.42915 8.36337 8.22013 8.46008 7.99998 8.46008Z"
        fill="#202020"
      />
    </svg>
  )
  const TSCollection =
    window.env && window.env.ENVIRONMENT === 'production' ? 'orders' : 'orders_staging'

  const typeSenseQueryStatus = () => {
    searchToken !== '' &&
      brandOrderUuid !== undefined &&
      brandOrderUuid !== null &&
      searchToken &&
      typesenseQuery(searchToken, typesenseConfig, TSCollection, projectStatusesParams)
        .then(result => {
          if (isMounted.current) {
            setProjectStatuses(result.facet_counts[0].counts)
          }
        })
        .catch(error => console.error('Failed to query Typesense:', error))
  }
  const projectStatusesParams: SearchParameters = {
    q: '',
    query_by:
      'name,orderId,locations.address,locations.cityName,locations.countryName,locations.countryCode,paymentType,projectStatus',
    filter_by: `organisations.id:${getDashboardId()}&&state:!=Lost`,
    facet_by: 'projectStatus',
  }

  React.useEffect(
    () => {
      typeSenseQueryStatus()
    },
    [searchToken, brandOrderUuid]
  )

  return (
    <SearchWrapper>
      <MainFlexWrapper>
        <StyledLabel>
          <CloudinaryImage
            useSourceFormat
            source={{
              id: 'v1590378211/-mobile/icon-search.svg',
              type: 'upload',
            }}
          />
          <StyledInput
            className={searchTerm !== '' ? 'filled' : ''}
            type="text"
            placeholder={placeholder || `Find people`}
            value={searchTerm}
            onChange={e => {
              onChange && onChange(e)
              setSearchTerm(e.target.value)
              onStateChangeFunction(statusOptionsData)
              localStorage.setItem('searchTerm', e.target.value)
            }}
          />
          {searchTerm !== '' && (
            <CloseButton
              onClick={() => {
                setSearchTerm('')
                onClearInput && onClearInput()
                onStateChangeFunction(statusOptionsData)
                localStorage.setItem('searchTerm', '')
              }}
            />
          )}
        </StyledLabel>
        {options && (
          <FlexWrapper>
            {statusOptionsData &&
              statusOptionsData.map((status, index) => (
                <FilterButton
                  className={status.active ? 'active' : ''}
                  key={status.id}
                  onClick={() => handleStatusData(index, setStatusOptionsData)}
                >
                  {status.name} ({status.count})
                </FilterButton>
              ))}
          </FlexWrapper>
        )}
      </MainFlexWrapper>
      {options && (
        <FiltersWrapper>
          <ButtonWrapper ref={wrapperRef} hide>
            <StatusButton
              onClick={() => setStatusDropdownActive(!statusDropdownActive)}
              className={statusDropdownActive ? 'active' : ''}
            >
              Status
              {arrowSvgIcon}
            </StatusButton>
            {statusDropdownActive && (
              <OptionDropdown>
                <ul>
                  {statusOptionsData &&
                    statusOptionsData.map((option, index) => (
                      <li key={index}>
                        <label>
                          <input
                            type="checkbox"
                            checked={option.active}
                            onChange={() => handleStatusData(index, setStatusOptionsData)}
                          />
                          {option.name}
                        </label>
                      </li>
                    ))}
                </ul>
              </OptionDropdown>
            )}
          </ButtonWrapper>

          <ButtonWrapper ref={wrapperRef}>
            <OptionButton
              onClick={() => setOptionDropdownActive(!optionDropdownActive)}
              className={optionDropdownActive ? 'active' : ''}
            >
              {optionIcon}
              Options
            </OptionButton>
            {optionDropdownActive && (
              <OptionDropdown>
                <ul>
                  {optionsData &&
                    optionsData.map((option, index) => (
                      <li key={index}>
                        <label>
                          <input
                            type="checkbox"
                            checked={option.active}
                            onChange={() => handleOptionsData(index, setOptionsData)}
                          />
                          {option.name === 'Created At' ? 'Creation Date' : option.name}
                        </label>
                      </li>
                    ))}
                </ul>
              </OptionDropdown>
            )}
          </ButtonWrapper>
        </FiltersWrapper>
      )}
      {!hideButton && (
        <StyledButton size="large" type="secondary" onClick={addMemberButton}>
          {buttonText ? buttonText : `Add new member`}
        </StyledButton>
      )}
    </SearchWrapper>
  )
}

export default React.memo(SearchSection)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/SearchSection/search-section.tsx